import {Controller, useFormContext} from 'react-hook-form';

import {Editor} from '@components/editor';
import type {EditorProps} from '@minimal/components/editor';

// ----------------------------------------------------------------------

export type TissotRhfEditorProps = EditorProps & {
  name: string;
};

export const TissotRhfEditor = ({name, helperText, ...other}: TissotRhfEditorProps) => {
  const {
    control,
    formState: {isSubmitSuccessful},
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => (
        <Editor
          {...field}
          error={!!error}
          helperText={error?.message ?? helperText}
          resetValue={isSubmitSuccessful}
          {...other}
        />
      )}
    />
  );
};
